module.exports = __webpack_public_path__ + "static/media/024.a514ac14.jpg";